import React from "react";
import { BlurWrapper, FloatLabelInput } from "../../Utils/CustomComponent";

const UseFormTextareaInput = ({
  title,
  type,
  field,
  register,
  watch,
  error,
  disable,
  blur = false,
  rows
}) => {
  return blur ? (
    <BlurWrapper>
      <FloatLabelInput
        register={{ ...register(field) }}
        label={title}
        value={watch(field) || ""}
        type={type || "text"}
        error={error}
        disabled={disable}
        rows={rows}
      />
    </BlurWrapper>
  ) : (
    <FloatLabelInput
      register={{ ...register(field) }}
      label={title}
      value={watch(field) || ""}
      type={type || "text"}
      error={error}
      disabled={disable}
      rows={rows}
    />
  );
};

export default UseFormTextareaInput;
